import { render, staticRenderFns } from "./CallStatusView.vue?vue&type=template&id=ce27bf28&scoped=true&lang=pug&"
import script from "./CallStatusView.vue?vue&type=script&lang=ts&"
export * from "./CallStatusView.vue?vue&type=script&lang=ts&"
import style0 from "./CallStatusView.vue?vue&type=style&index=0&id=ce27bf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce27bf28",
  null
  
)

export default component.exports